import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import projImg4 from "../assets/img/Salary1.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { useNavigate } from "react-router-dom";
export const Projects = () => {
 // const navigate = useNavigate();
  // const openSourceCode = () => {
  //   window.open('https://github.com/siraz1995/InventoryBeginners', '_blank');
  // };
  const openSourceCode = () => {
    //window.open('https://github.com/siraz1995/InventoryBeginners', '_blank');
    //navigate("/documentmanagement");
  };
  const projects = [
    {
      title: "Business Startup",
      description: "Design & Development",
      imgUrl: projImg1,
    },
    {
      title: "Business Startup",
      description: "Design & Development",
      imgUrl: projImg2,
    },
    {
      title: "Business Startup",
      description: "Design & Development",
      imgUrl: projImg3,
    },
    {
      title: "Business Startup",
      description: "Design & Development",
      imgUrl: projImg1,
    },
    {
      title: "Business Startup",
      description: "Design & Development",
      imgUrl: projImg2,
    },
    {
      title: "Business Startup",
      description: "Design & Development",
      imgUrl: projImg3,
      
    },
  ];
  const individualprojects = [
    {
      title: "Business Startup",
      description: "Design & Development",
      imgUrl: projImg1,
      sourchUrl:"https://github.com/siraz1995/personal-portfolio",
    },
    {
      title: "Business Startup",
      description: "Design & Development",
      imgUrl: projImg2,
    },
    {
      title: "Business Startup",
      description: "Design & Development",
      imgUrl: projImg3,
    },
    
  ];
  const cardData = [
    {
      id: 1,
      title: 'Card 1',
      description: 'Description for Card 1',
      imageSrc: 'path-to-image-1.jpg',
      buttonText: 'url',
    },
    {
      id: 2,
      title: 'Card 2',
      description: 'Description for Card 2',
      imageSrc: 'path-to-image-2.jpg',
      buttonText: 'Go somewhere else',
    },
    // Add more card objects as needed
  ];
  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p>I have successfully completed numerous projects during my professional tenure. Below, I present information about some of these projects along with their respective source code URLs.</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Team Work Project</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Individual Project</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Course Project</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      {/* <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row> */}
                                       <div>
      <Row>
        <Col>
          <Card  className="card" style={{ width: '25rem', height:'20rem' }}>
            {/* Card content */}
            <Card.Body>
              <Card.Title style={{color:'blue',fontSize:'30px'}}>Salaey, CPF & Loan Management System</Card.Title>
              <Card.Text style={{ color: 'black', fontSize: '18px', textAlign: 'justify', marginLeft: '10px',width:'90%',}}>It is a government project to calculate the salary, CPF (Central Provident Fund), and loan details for an employee of the Bangladesh Jute Research Institute (BJRI).</Card.Text>
              <Button variant="primary" onClick={openSourceCode}>
                Source Code
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="card"  style={{ width: '25rem', height:'20rem' }}>
            {/* Card content */}
            <Card.Body>
              <Card.Title style={{color:'blue',fontSize:'30px'}}>Queue Management System</Card.Title>
              <Card.Text style={{ color: 'black', fontSize: '18px', textAlign: 'justify', marginLeft: '10px',width:'90%',marginTop:'20px'}}>It is a government project to provide service for service receiver of Military Institute of Science and Technology (MIST).</Card.Text>
              <Button variant="primary" onClick={openSourceCode} style={{marginTop:'20px'}}>
                Source Code
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="card"  style={{ width: '25rem', height:'20rem'}}>
            {/* Card content */}
            <Card.Body>
              <Card.Title style={{color:'blue',fontSize:'30px'}}>Visitor Management System</Card.Title>
              <Card.Text style={{ color: 'black', fontSize: '16px', textAlign: 'justify', marginLeft: '10px',width:'90%',marginTop:'20px'}}>It is a government project(Bangladesh Secretariat) designed for visitor pass applications, with an approval process by authorized users.</Card.Text>
              <Button variant="primary" onClick={openSourceCode} style={{marginTop:'28px'}}>
                Source Code
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
    <div className="mt-5">
      <Row>
        <Col>
          <Card  className="card" style={{ width: '25rem', height:'20rem' }}>
            {/* Card content */}
            <Card.Body>
              <Card.Title style={{color:'blue',fontSize:'30px'}}>Appointment Management System</Card.Title>
              <Card.Text style={{ color: 'black', fontSize: '18px', textAlign: 'justify', marginLeft: '10px',width:'90%',}}>This is a online doctor appointment system from where a person get doctor appointment.</Card.Text>
              <Button variant="primary" onClick={openSourceCode} style={{marginTop:'50px'}}>
                Source Code
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="card"  style={{ width: '25rem', height:'20rem' }}>
            {/* Card content */}
            <Card.Body>
              <Card.Title style={{color:'blue',fontSize:'30px'}}>Access Control System</Card.Title>
              <Card.Text style={{ color: 'black', fontSize: '18px', textAlign: 'justify', marginLeft: '10px',width:'90%',marginTop:'20px'}}>This is a government(Bangladesh Secretariat) project which are electronic systems that allow authorized personnel to enter controlled and restricted.</Card.Text>
              <Button variant="primary" onClick={openSourceCode} style={{marginTop:'20px'}}>
                Source Code
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="card"  style={{ width: '25rem', height:'20rem'}}>
            {/* Card content */}
            <Card.Body>
              <Card.Title style={{color:'blue',fontSize:'30px'}}>Meeting Management System</Card.Title>
              <Card.Text style={{ color: 'black', fontSize: '16px', textAlign: 'justify', marginLeft: '10px',width:'90%'}}>This is a single-page application using jQuery and Ajax. The project checks the validity of library entries at the entrance of the central library of Dhaka University through a gate.</Card.Text>
              <Button variant="primary" onClick={openSourceCode} >
                Source Code
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                   <div>
      <Row>
        <Col>
          <Card  className="card" style={{ width: '25rem', height:'20rem' }}>
            {/* Card content */}
            <Card.Body>
              <Card.Title style={{color:'blue',fontSize:'30px'}}>License & Support Management System</Card.Title>
              <Card.Text style={{ color: 'black', fontSize: '18px', textAlign: 'justify', marginLeft: '10px',width:'90%',}}>It is own application of Interlink Technologies for
manage hardware & software license , save record & support history of
client.</Card.Text>
              <Button variant="primary" onClick={openSourceCode}>
                Source Code
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="card"  style={{ width: '25rem', height:'20rem' }}>
            {/* Card content */}
            <Card.Body>
              <Card.Title style={{color:'blue',fontSize:'30px'}}>Queue Ratings</Card.Title>
              <Card.Text style={{ color: 'black', fontSize: '18px', textAlign: 'justify', marginLeft: '10px',width:'90%',marginTop:'20px'}}>A service recipient receives service in a single queue and provides a review or rating based on their satisfaction.</Card.Text>
              <Button variant="primary" onClick={openSourceCode} style={{marginTop:'25px'}}>
                Source Code
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col>
     
          <Card className="card"  style={{ width: '25rem', height:'20rem' }}>
            {/* Card content */}
            <Card.Body>
            <Card.Title style={{color:'blue',fontSize:'26px'}}>Visitor Management System (Microservice Architecture)</Card.Title>
              {/* <Card.Title style={{color:'blue',fontSize:'22px'}}>Visitor Management(MicroService)</Card.Title> */}
              <Card.Text style={{ color: 'black', fontSize: '16px', textAlign: 'justify', marginLeft: '10px',width:'90%',marginTop:'10px'}}>This project includes User Management, Visitor Management, Access Management, Card Management and Employee Management.</Card.Text>
              <Button variant="primary" onClick={openSourceCode} style={{marginTop:'20px'}}>
                Source Code
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <div className="mt-5">
        <Col>
          <Card className="card"  style={{ width: '25rem', height:'20rem'}}>
            {/* Card content */}
            <Card.Body>
              <Card.Title style={{color:'blue',fontSize:'30px'}}>Library Card of Dhaka University</Card.Title>
              <Card.Text style={{ color: 'black', fontSize: '16px', textAlign: 'justify', marginLeft: '10px',width:'90%',marginTop:'-5px'}}>This is a single-page application using jQuery and Ajax. The project checks the validity of library entries at the entrance of the central library of Dhaka University through a gate.</Card.Text>
              <Button variant="primary" onClick={openSourceCode} >
                Source Code
              </Button>
            </Card.Body>
          </Card>
        </Col>
        </div>
      </Row>
      
    </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                    <div>
      <Row>
        <Col>
          <Card  className="card" style={{ width: '25rem', height:'20rem' }}>
            {/* Card content */}
            <Card.Body>
              <Card.Title style={{color:'blue',fontSize:'30px'}}>Inventory Management System</Card.Title>
              <Card.Text style={{ color: 'black', fontSize: '18px', textAlign: 'justify', marginLeft: '10px',width:'90%',}}>It is own application of Interlink Technologies for
manage hardware & software license , save record & support history of
client.</Card.Text>
              <Button variant="primary" onClick={openSourceCode}>
                Source Code
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="card"  style={{ width: '25rem', height:'20rem' }}>
            {/* Card content */}
            <Card.Body>
              <Card.Title style={{color:'blue',fontSize:'30px'}}>Management Console</Card.Title>
              <Card.Text style={{ color: 'black', fontSize: '18px', textAlign: 'justify', marginLeft: '10px',width:'90%',marginTop:'20px'}}>A service recipient receives service in a single queue and provides a review or rating based on their satisfaction.</Card.Text>
              <Button variant="primary" onClick={openSourceCode} style={{marginTop:'25px'}}>
                Source Code
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="card"  style={{ width: '25rem', height:'20rem'}}>
            {/* Card content */}
            <Card.Body>
              <Card.Title style={{color:'blue',fontSize:'30px'}}>Warehouse Management System</Card.Title>
              <Card.Text style={{ color: 'black', fontSize: '16px', textAlign: 'justify', marginLeft: '10px',width:'90%',marginTop:'-5px'}}>This is a single-page application using jQuery and Ajax. The project checks the validity of library entries at the entrance of the central library of Dhaka University through a gate.</Card.Text>
              <Button variant="primary" onClick={openSourceCode} >
                Source Code
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}